import React from "react";
import { Alert } from "@zendeskgarden/react-notifications";

// 定义一个RenderInlineNotification函数，接收closeToast、kind和message三个参数
const RenderInlineNotification = ({ closeToast, type = "info", message, title }) => {
  return (
    <div className="">
      <Alert type={type} className="max-w-3xl mt-6">
        <Alert.Title>{title}</Alert.Title>
        {message}
        <Alert.Close aria-label="Close Info Alert" onClick={closeToast} />
      </Alert>
    </div>
  );
};
export default RenderInlineNotification;
